import Component from './component';
import Connector from './connector';

const DashboardCardEntityTransactions = () => <Connector component={Component} />;

export default DashboardCardEntityTransactions;

export * from './DashboardCardEntityTransactions.proptype';
